import { root, IFrontendLogger } from '@estee/elc-universal-utils';
import { validate } from './ELCLoggerValidations';
import { ILogData, IFullData } from './ELCLogger';

export class LoggerApiSDK {
    private loggingServiceUrl: string = '/stardust-fe-logging-v0/logMessage';
    private queue: ILogData[] = [];
    private isRequestIdleCallbackScheduled: boolean;
    private lastTimeExecuted: number = Date.now();
    private frontendLogger: IFrontendLogger = root.site ? root.site.frontendLogger || {} : {};

    private generateRequestBody(fullData: IFullData) {
        const { config, level, logdata } = fullData;

        const { payload = {}, message, triggerType } = logdata;
        const {
            serviceName: payloadServiceName,
            serviceVersion: payloadServiceVersion,
            context,
            error
        } = payload;

        const {
            serviceName: configServiceName,
            serviceVersion: configServiceVersion,
            buid: configBuid,
            environment: configEnvironment
        } = config;
        const stringifiedError = error && JSON.stringify(error, Object.getOwnPropertyNames(error));

        return {
            context: {
                ...context,
                date: new Date().toUTCString(),
                error: stringifiedError
            },
            environment: configEnvironment || root.env,
            level: level,
            message,
            serviceName: payloadServiceName || configServiceName,
            serviceVersion: payloadServiceVersion || configServiceVersion,
            siteUrl: root.location.href,
            buid: configBuid || root.buid,
            triggerType,
            userAgent: root.navigator.userAgent
        };
    }

    public sendLog(fullData: IFullData) {
        const requestBody = this.generateRequestBody(fullData);
        const loggedServices = this.frontendLogger.loggedServices || {};
        const serviceConfig = loggedServices[requestBody.serviceName] || {};
        const isServiceEnabled = serviceConfig.isEnabled;

        if (this.frontendLogger.isEnabled && isServiceEnabled) {
            if (!validate(requestBody)) {
                throw new Error(`Request body for error logging did not validate`);
            }

            this.addLogToQueue(requestBody);
        }
    }

    public addLogToQueue = (log: ILogData) => {
        this.queue.push(log);
        this.schedulePendingEvents();
    };

    private schedulePendingEvents = () => {
        if (this.isRequestIdleCallbackScheduled) {
            return;
        }

        this.isRequestIdleCallbackScheduled = true;
        root.requestIdleCallback(this.processPendingLogs);
    };

    private processPendingLogs = () => {
        this.isRequestIdleCallbackScheduled = false;

        if (this.queue.length > 0 && Date.now() - this.lastTimeExecuted > 2000) {
            root.HttpTransport.post({
                url: this.loggingServiceUrl,
                body: this.queue
            }).catch(() => console.error('Errors failed to be sent to sumoLogic', this.queue));

            this.queue = [];
            this.lastTimeExecuted = Date.now();
        }

        if (this.queue.length > 0) {
            this.schedulePendingEvents();
        }
    };
}
